import { MutableRefObject, useEffect } from 'react';
import { useVisitorSpyOptinState } from 'shared/hooks';
import { subscribeToRrweb, unsubscribeToRrweb } from 'shared/realtime';

const OVERLAY_ID = '___sb_optin_overlay___';

export const RrwebOptinOverlayInjector: React.FC<{
  rrwebIframeWrapper: MutableRefObject<HTMLDivElement | null>;
}> = ({ rrwebIframeWrapper }) => {
  const { isShowOverlay } = useVisitorSpyOptinState();

  useEffect(
    function updateIframeReferenceEffect() {
      const updateIframe = () => {
        if (rrwebIframeWrapper.current) {
          const iframes = rrwebIframeWrapper.current.getElementsByTagName('iframe');
          if (iframes.length) {
            const iframe = iframes[0];
            const document = iframe.contentDocument;
            if (document) {
              const iframeBody = document.getElementsByTagName('body')[0];
              const element = document.getElementById(OVERLAY_ID);
              if (!element && isShowOverlay) {
                const div = document.createElement('div');
                div.id = OVERLAY_ID;
                div.style.position = 'fixed';
                div.style.top = '-1px';
                div.style.left = '-1px';
                div.style.right = '-1px';
                div.style.bottom = '-1px';
                div.style.backgroundColor = 'rgba(12, 18, 46, 1)';
                div.style.zIndex = '2147483645';
                iframeBody.appendChild(div);
              } else if (element && !isShowOverlay) {
                iframeBody.removeChild(element);
              }
            }
          }
        }
      };
      subscribeToRrweb(updateIframe);
      return () => unsubscribeToRrweb(updateIframe);
    },
    [rrwebIframeWrapper, isShowOverlay],
  );

  return null;
};
